import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import StructureModel from '@Components/Results/structure/structure-model.service';
import ReactReactionDetailsHelper from '@Components/Results/services/react-reaction-details-helper.service';
import ReactionViewItem from '@Components/Results/reactions/ReactionViewItem';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { isNewSynthesisPlannerEnabled } from '@Pages/RetroSynthesis/predictiveUtils';

function ReactionView({ metadata, reactants, products, zoom, showToolbar, reactionId }) {
  const getList = (structures = [], isProducts = false, trailingArrow = false) => {
    const containsSubstanceWithNoStructure =
      (!isEmpty(reactants) && reactants?.filter((reactant) => reactant?.molImage && !reactant?.molImage?.structure)?.length) ||
      (!isEmpty(products) && products?.filter((product) => product?.molImage && !product?.molImage?.structure)?.length);
    const displayTransferTo =
      showToolbar &&
      isProducts &&
      !isEmpty(reactants) &&
      !isEmpty(products) &&
      products?.length === 1 &&
      !containsSubstanceWithNoStructure &&
      isNewSynthesisPlannerEnabled();
    return structures.length
      ? structures.map((structure, i) => (
          <ReactionViewItem
            /* eslint-disable-next-line react/no-array-index-key */
            key={i}
            structure={structure}
            isProduct={isProducts}
            trailingArrow={trailingArrow}
            metadata={metadata}
            structureTitle={
              isProducts && getValueByNs({ products }, 'products.length') > 1 ? ReactReactionDetailsHelper.getLetterTitle(i) : null
            }
            zoom={zoom}
            isFirst={i === 0}
            isLast={i === structures.length - 1}
            showToolbar={showToolbar}
            reactionId={reactionId}
            displayTransferTo={displayTransferTo}
          />
        ))
      : null;
  };

  return (
    <div
      className="structure-container rx-focusable"
      data-summary-reference-target={!metadata.fromRT ? 'reaction' : undefined}
      role="group"
      aria-label={reactionId ? `Reaction ${reactionId}` : 'Reaction'}
      tabIndex={-1}>
      {getList(reactants, false, isEmpty(products))}
      {getList(products, true, false)}
    </div>
  );
}
/* eslint-enable jsx-a11y/no-noninteractive-tabindex */

ReactionView.propTypes = {
  metadata: PropTypes.object.isRequired,
  reactants: PropTypes.arrayOf(PropTypes.instanceOf(StructureModel)).isRequired,
  products: PropTypes.arrayOf(PropTypes.instanceOf(StructureModel)).isRequired,
  zoom: PropTypes.number,
  showToolbar: PropTypes.bool,
  reactionId: PropTypes.string.isRequired,
};

export default ReactionView;
